import { EPatientStatusNumeric } from '@mybonum/api';
import { TableColumnType, Tag } from 'antd';

import { TPatientType } from '../types.ts';

import { PATIENT_STATUS_MAP } from '@/constants/patients.ts';
import { useTableSortColumns } from '@/hooks';

export const useColumns = (): TableColumnType<TPatientType>[] => {
    const sortColumns = useTableSortColumns<TPatientType>();

    return sortColumns([
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
        },
        {
            key: 'firstName',
            title: 'First Name',
            dataIndex: 'firstName',
        },
        {
            key: 'lastName',
            title: 'Last Name',
            dataIndex: 'lastName',
        },
        {
            key: 'email',
            title: 'Email',
            dataIndex: 'email',
        },
        {
            key: 'createdDate',
            title: 'Created Date',
            dataIndex: 'createdDate',
        },
        {
            key: 'birthdate',
            title: 'Birthdate',
            dataIndex: 'birthdate',
        },
        {
            key: 'gender',
            title: 'Sex/Gender',
            dataIndex: 'gender',
        },
        {
            key: 'primaryLanguage',
            title: 'Primary Language',
            dataIndex: 'primaryLanguage',
        },
        {
            key: 'secondaryLanguage',
            title: 'Secondary Language',
            dataIndex: 'secondaryLanguage',
        },
        {
            key: 'status',
            title: 'Status',
            render: (_, record) => {
                return (
                    <Tag
                        color={record.status === EPatientStatusNumeric.Active ? 'green' : 'default'}
                    >
                        {PATIENT_STATUS_MAP.get(record.status)}
                    </Tag>
                );
            },
        },
    ]);
};
